import { SettingsRoutes } from 'pages/settings/route/type'
import { SavedRepliesRoutes } from 'pages/settings/pages/savedReplies/route/type'

const savedReplies = `/${SettingsRoutes.root}/${SavedRepliesRoutes.root}`

export const SavedRepliesPath = {
  root: savedReplies,
  create: `${savedReplies}/${SavedRepliesRoutes.create}`,
}
